const environment = process.env.ENVIRONMENT

export default environment
